import React, { useState } from "react";
import { updateStatus as serviceUpdateStatus } from "../../services/settingsService";
import styles from "./HiddenFields.module.css";
import { useSettingsState } from "../../state/settingsState";

const HiddenFields = () => {
  const { 
    fields, 
    hiddenFields, 
    setHiddenFields, 
    selectedStatus 
  } = useSettingsState();
  
  const [search, setSearch] = useState("");

  const handleToggleHiddenField = (fieldId) => {
    const updatedHiddenFields = hiddenFields.includes(fieldId)
      ? hiddenFields.filter((id) => id !== fieldId)
      : [...hiddenFields, fieldId];
    
    setHiddenFields(updatedHiddenFields);

    const status = { ...selectedStatus };
    delete status["checklists"];
    serviceUpdateStatus(status.amo_status_id, {
      ...status,
      hidden_fields: updatedHiddenFields,
    });
  };

  const filteredFields = fields.filter((field) =>
    field.NAME.toLowerCase().includes(search.toLowerCase()) &&
    (field.ENTREE_DEALS === 1 || hiddenFields.includes(field.ID))
  );

  return (
    <div className={styles.hiddenFields}>
      <h3 className={styles.sectionTitle}>Скрытые поля</h3>
      <input
        type="text"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        placeholder="Поиск скрытых полей"
        className={styles.inputField}
      />
      <ul className={styles.fieldList}>
        {filteredFields.map((field) => (
          <li
            key={field.ID}
            className={styles.fieldItem}
            onClick={() => handleToggleHiddenField(field.ID)}
          >
            {field.NAME} {hiddenFields.includes(field.ID) ? "(скрыто)" : ""}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default HiddenFields;
